var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsCard',[_c('WsFlex',[(_vm.title)?_c('WsTitle',{staticClass:"flex-0",attrs:{"size":"5"}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('WsSpacer'),_vm._t("titleright")],2),_c('WsMain',[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }